// extracted by mini-css-extract-plugin
export default {"citiesListContainer":"classes@desktop_citiesListContainer__qnAP8","citiesListTitle":"classes@desktop_citiesListTitle__Khnup"};